import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// UTILS
import { limparMascara } from 'utils/genericFunctions';

// ACTIONS
import {
	cadastraDocumentosSuccess,
	cadastraDocumentosFailure,
} from './actions';

// TYPES
import { CadastraDocumentosRequest, Types } from './types';

function* cadastraDocumentosRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastraDocumentosRequest } = request;

	const treatedPayload = {
		...payload,
		rg: limparMascara(payload.rg),
		cpf: limparMascara(payload.cpf),
	};

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`documentos/`,
		treatedPayload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastraDocumentosSuccess());
	} else if (response.error) {
		yield put(cadastraDocumentosFailure());
	}
}

export default all([
	takeLatest(Types.CADASTRA_DOCUMENTOS_REQUEST, cadastraDocumentosRequest),
]);
